"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GitHubAppInstallStatus = exports.GitHubAppInstallQueryField = void 0;
var github_app_install_query_field_enum_1 = require("./github-app-install-query-field.enum");
Object.defineProperty(exports, "GitHubAppInstallQueryField", { enumerable: true, get: function () { return github_app_install_query_field_enum_1.GitHubAppInstallQueryField; } });
var github_app_install_status_enum_1 = require("./github-app-install-status.enum");
Object.defineProperty(exports, "GitHubAppInstallStatus", { enumerable: true, get: function () { return github_app_install_status_enum_1.GitHubAppInstallStatus; } });
